<template>
	<svg
		width="18"
		height="18"
		viewBox="0 0 18 18"
		:class="{ 'text-disabled': isDisabled }"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M4 10L8 6L12 10"
			stroke="currentColor"
			stroke-width="2"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>

<script>
export default {
	name: "ArrowUp",
	props: {
		isDisabled: {
			type: Boolean,
			default: false,
		},
	},
};
</script>
